import VatRate from '../Models/VatRate';
import DataGridRequest from './DataGridRequest';
export class VatRateRequest extends DataGridRequest<VatRate> {
    Url = 'tax_rates/api';
}
